export default __webpack_public_path__ + "static/media/geometry.e35a4b0b.png";